import React, { Component } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormGroup,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import jwt from 'jsonwebtoken';
import s from './Dashboard.module.scss';
import './main.css'

import { fetchDashboard, createDashboard } from '../../actions/dashboard';
import { USER_ROLE } from '../../constants';
import moment from 'moment';
import EditorArea from './EditorArea';
import { Link } from 'react-router-dom';
class Dashboard extends Component {
  /* eslint-disable */
  static propTypes = {
    dashboard: PropTypes.any,
    isFetching: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    message: PropTypes.string,
  };
  /* eslint-enable */

  static defaultProps = {
    isFetching: false,
    dashboard: {},
    message: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      currUser: {},
      modalToggleNewDashboard: false,
      newDashboard: { title: '', body: '', highlight: false, role: '' },
      isOpenToast: false,
    };
    this.onAddnewDashboard = this.onAddnewDashboard.bind(this);
    this.onChangeNewDashboard = this.onChangeNewDashboard.bind(this);
    this.toggleNewDashboard = this.toggleNewDashboard.bind(this);
  }

  toggleNewDashboard() {
    this.setState({
      modalToggleNewDashboard: !this.state.modalToggleNewDashboard,
    });
  }

  onAddnewDashboard(e) {
    e.preventDefault();
    this.props.dispatch(createDashboard(this.state.newDashboard));
    this.toggleNewDashboard();
    this.setState({
      isOpenToast: true,
      newDashboard: { title: '', body: '', highlight: false, role: '' },
    });
  }

  onChangeNewDashboard(e, name) {
    // if (e.target.name === 'highlight') {
    //   this.setState({
    //     newDashboard: {
    //       ...this.state.newDashboard,
    //       [e.target.name]: e.target.checked,
    //     },
    //   });
    //   return;
    // }
    if (name) {
      this.setState({
        newDashboard: {
          ...this.state.newDashboard,
          [name]: e,
        },
      });
      return;
    }
    this.setState({
      newDashboard: {
        ...this.state.newDashboard,
        [e.target.name]: e.target.value,
      },
    });
  }

  componentDidMount() {
    let token = localStorage.getItem('id_token');
    let currUser = jwt.decode(token);
    this.setState({ currUser: currUser });

    this.props.dispatch(fetchDashboard());
  }

  render() {
    let { dashboard, loading } = this.props;
    const userRole = this.state.currUser.role;
    if (userRole !== USER_ROLE.ADMIN) {
        dashboard = dashboard.filter((item) => item.role === userRole || !item.role);
    }
    if (userRole === 'ops') {
      dashboard = dashboard.filter(item => item.role === 'ops')
    }

    if (this.props.message && this.state.isOpenToast) {
      toast.error(this.props.message);
      this.setState({ isOpenToast: false });
    }
    const sortedDashboard = dashboard.sort(
      (a, b) => moment(b.updatedAt) - moment(a.updatedAt)
    );

    return (
      <div className={s.root}>
        <ToastContainer position='top-right' autoClose={3000} hideProgressBar />

        {/* Breadcrumbs */}
        <div className={s.breadcrumbContainer}>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Hệ thống</li>
              <li className="breadcrumb-item active" aria-current="page">Thông báo & Tin tức</li>
            </ol>
          </nav>
        </div>

        {/* Header */}
        <div className={s.headerRow}>
          <div className={s.titleSection}>
            <h2>Thông báo chung</h2>
            <p>Cập nhật tin tức và thông báo quan trọng từ hệ thống</p>
          </div>
          
          {this.state.currUser.role === USER_ROLE.ADMIN && (
            <div className={s.actionGroup}>
              <button className={cx(s.btnPremium, s.btnPremiumAdd)} onClick={this.toggleNewDashboard}>
                <i className='fa fa-plus-circle' /> Thêm thông báo
              </button>
            </div>
          )}
        </div>

        {/* Notifications List */}
        <div className={s.listContainer}>
          {loading ? (
            <div className="text-center py-5">
              <i className="fa fa-circle-o-notch fa-spin fa-2x text-primary" />
              <p className="mt-2 text-muted">Đang tải thông báo...</p>
            </div>
          ) : sortedDashboard.length > 0 ? (
            sortedDashboard.map((item) => (
              <div key={item.id} className={cx(s.pricingCard, s.pricingCardItem)}>
                <div className={s.cardLeft}>
                  <div className={s.itemIcon} style={{ color: item.highlight ? '#ef4444' : '#3b82f6' }}>
                    <i className={cx('fa', item.highlight ? 'fa-bullhorn' : 'fa-bell-o')} />
                  </div>
                  <div className="flex-grow-1">
                    <Link to={`/app/main/${item.id}`} className={s.cardTitle}>
                      <span className={cx(s.title, { 'text-danger fw-bold': item.highlight })}>
                        {item.title || 'Thông báo không có tiêu đề'}
                      </span>
                    </Link>
                    <div className="d-flex align-items-center mt-1">
                      <span className="badge badge-light-primary text-uppercase mr-2" style={{ fontSize: '10px', background: '#f1f5f9', color: '#64748b' }}>
                        {item.role || 'Gửi tất cả'}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            ))
          ) : (
            <div className={s.pricingCard} style={{ justifyContent: 'center', padding: '40px' }}>
              <div className="text-center text-muted">
                <i className="fa fa-inbox fa-3x mb-3 opacity-20" />
                <p>Hiện tại không có thông báo nào dành cho bạn</p>
              </div>
            </div>
          )}
        </div>

        {/* Modal for New Notification */}
        <Modal
          isOpen={this.state.modalToggleNewDashboard}
          toggle={this.toggleNewDashboard}
          size="lg"
        >
          <ModalHeader>Tạo mới thông báo</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for='title'>Tiêu đề</Label>
              <Input
                value={this.state.newDashboard.title}
                name='title'
                id='title'
                placeholder='Nhập tiêu đề thông báo...'
                onChange={(e) => this.onChangeNewDashboard(e)}
              />
            </FormGroup>
            <FormGroup style={{ minHeight: '400px' }}>
              <Label for='content'>Nội dung chi tiết</Label>
              <EditorArea
                value={this.state.newDashboard.body}
                onChange={(e) => this.onChangeNewDashboard(e, 'body')}
              />
            </FormGroup>
            
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="roleSelect">Thông báo cho nhóm</Label>
                  <select 
                    id="roleSelect"
                    className="form-control"
                    name='role'
                    value={this.state.newDashboard.role}
                    onChange={(e) => this.onChangeNewDashboard(e)}
                  >
                    <option value="">Tất cả các bộ phận</option>
                    {Object.values(USER_ROLE).map((role) => (
                      <option key={role} value={role}>{role.toUpperCase()}</option>
                    ))}
                  </select>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="d-flex align-items-center h-100 pt-3">
                  <div className="abc-checkbox abc-checkbox-danger">
                    <Input 
                      id="highlightNotify" 
                      name="highlight" 
                      type="checkbox" 
                      checked={this.state.newDashboard.highlight}
                      onChange={(e) => this.onChangeNewDashboard({ target: { name: 'highlight', value: e.target.checked } })}
                    />
                    <Label for="highlightNotify">Nổi bật (Quan trọng)</Label>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
             <Button color='success' className="px-4" onClick={(e) => this.onAddnewDashboard(e)}>Phát hành thông báo</Button>
             <Button color='secondary' onClick={this.toggleNewDashboard}>Huỷ bỏ</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isFetching: state.dashboard.isFetching,
    dashboard: state.dashboard.dashboard,
    message: state.dashboard.message,
  };
}

export default connect(mapStateToProps)(Dashboard);
